import { FluidStore } from '../../../utils/store/store.class';

export interface ElementStoreState {
  paginator?: HTMLFluidPaginatorElement;
}
export class TableElementStore extends FluidStore<ElementStoreState> {
  constructor(initialState: ElementStoreState) {
    super(initialState);
  }

  setPaginator(paginatorRef: HTMLFluidPaginatorElement): void {
    this.setValue('paginator', paginatorRef);
  }

  getPaginator(): HTMLFluidPaginatorElement {
    return this.getValue('paginator') as HTMLFluidPaginatorElement;
  }
}
